import defaultValue from "../Core/defaultValue.js";
import defined from "../Core/defined.js";

function EV_IndexedDBProvider(indexedDB) {
  this._windowIDB = defaultValue(indexedDB, undefined);
  this._iDB = undefined;
}

Object.defineProperties(EV_IndexedDBProvider.prototype, {
  iDB: {
    get: function() {
      return this._iDB;
    }
  }
});

EV_IndexedDBProvider.prototype.createIDB = function(dataName, version, tableNames, callbackFunc) {
  if (defined(this._windowIDB)) {
    var that = this;
    var requestIDB = this._windowIDB.open(dataName, version);

    requestIDB.onupgradeneeded = function(event) {
      var db = event.target.result;
      //that._iDB = db;
      for (var i = 0; i < tableNames.length; i++) {
        if (!db.objectStoreNames.contains(tableNames[i])) {
          var objStore = db.createObjectStore(tableNames[i], { keyPath: "key", autoIncrement: true });
          if (tableNames[i] === "model") {
            objStore.createIndex("name", "name", { unique: false });
          } else {
            objStore.createIndex("name", "name", { unique: true });
          }
        }
      }
      if (defined(callbackFunc)) {
        callbackFunc("upgradeneeded");
      }
    };

    requestIDB.onsuccess = function(event) {
      var db = event.target.result;
      that._iDB = db;
      if (defined(callbackFunc)) {
        callbackFunc("success");
      }
      //console.log("createIDB sucess!");
    };

    requestIDB.onerror = function(event) {
      if (defined(callbackFunc)) {
        callbackFunc("error");
      }
      alert("Why didn't you allow my web app to use IndexedDB?!");
    };
  }
};

EV_IndexedDBProvider.closeIDB = function(dataName, version) {
  if (defined(this._iDB) && this._iDB.name === dataName && this._iDB.version === version) {
    this._iDB.close();
  }
};

// This is needed as chromium has a limit on per-entry files in IndexedDB
// https://cs.chromium.org/chromium/src/content/renderer/indexed_db/webidbdatabase_impl.cc?type=cs&sq=package:chromium&g=0&l=177
// https://cs.chromium.org/chromium/src/out/Debug/gen/third_party/blink/public/mojom/indexeddb/indexeddb.mojom.h?type=cs&sq=package:chromium&g=0&l=60
// We set the chunk size to 64MB to stay well-below the limit
var CHUNK_SIZE = 64 * 1024 * 1024;

EV_IndexedDBProvider.prototype.saveModelArrayBuffer = function(dataName, version, tableName, modelName, arrayBuffer) {
  if (defined(this._iDB) && this._iDB.name === dataName && this._iDB.version === version) {
    if (this._iDB.objectStoreNames.contains(tableName)) {
      var transaction = this._iDB.transaction([tableName], "readwrite");
      var objectStore = transaction.objectStore(tableName);
      var chunkSliceStart = 0;
      var nextChunkSliceStart = 0;
      var chunkCount = Math.ceil(arrayBuffer.byteLength / CHUNK_SIZE);
      for (var chunkId = 0; chunkId < chunkCount; chunkId++) {
        nextChunkSliceStart += CHUNK_SIZE;
        var value = {
          "name": modelName,
          "chunkId": chunkId,
          "data": arrayBuffer.slice(chunkSliceStart, nextChunkSliceStart)
        };
        var putPackageRequest = objectStore.put(value);

        chunkSliceStart = nextChunkSliceStart;
        putPackageRequest.onsuccess = function(event) {
          console.log("arraybuffer writed success");
        };

        putPackageRequest.onerror = function(error) {
          console.log("arraybuffer writed error");
        };
      }
    }
    else {
      console.log(tableName + ":该表不存在!");
    }
  } else {
    console.log(dataName + ":保存数据有问题!");
  }
};

EV_IndexedDBProvider.prototype.downloadModelArrayBuffer = function(dataName, version, tableName, modelName, model, errorCallback, successCallback) {
  if (defined(this._iDB) && this._iDB.name === dataName && this._iDB.version === version) {
    if (this._iDB.objectStoreNames.contains(tableName)) {
      var transaction = this._iDB.transaction([tableName], "readonly");
      var objectStore = transaction.objectStore(tableName);

      var curModel = model;
      var curModelName = modelName;
      var arrayBufferList = new Array();
      var totalLength = 0;
      var index = objectStore.index("name");
      var reqCursor = index.openCursor(IDBKeyRange.only(modelName));
      reqCursor.onsuccess = function(e) {
        var cursor = e.target.result;
        if (cursor) {
          console.log(cursor.key);
          var curValue = cursor.value;
          if (curValue.name === curModelName) {
            var array = new Uint8Array(curValue.data);
            arrayBufferList.push(array);
            totalLength += array.byteLength;
          }
          cursor.continue();
        } else {
          var offset = 0;
          var resultArrayBuffer = new Uint8Array(totalLength);
          for (var index = 0; index < arrayBufferList.length; index++) {
            resultArrayBuffer.set(arrayBufferList[index], offset);
            offset += arrayBufferList[index].length;
          }

          if (arrayBufferList.length > 0) {
            successCallback(curModel, resultArrayBuffer);
          } else {
            errorCallback(curModel);
          }
        }
      };

      reqCursor.onerror = function(e) {
        console.log("索引查询失败!");
      };
    }
    else {
      errorCallback(model);
    }
  } else {
    console.log(dataName + ":下载数据有问题!");
  }
};

EV_IndexedDBProvider.prototype.saveTerrainData = function(dataName, version, tableName, terrainData) {
  if (defined(this._iDB) && this._iDB.name === dataName && this._iDB.version === version) {
    if (this._iDB.objectStoreNames.contains(tableName)) {
      var transaction = this._iDB.transaction([tableName], "readwrite");
      var objectStore = transaction.objectStore(tableName);
      /*               if(Math.ceil(terrainData.data.byteLength / CHUNK_SIZE) > 1){
                         console.log('error:This is needed as chromium has a limit 60MB on per-entry files in IndexedDB');
                     }*/
      var name = terrainData.keyName;
      var value = {
        "name": name,
        "level": terrainData.level,
        "x": terrainData.x,
        "y": terrainData.y,
        "data": terrainData.data,
        "upsample": defaultValue(terrainData.upsample, false)
      };
      var putPackageRequest = objectStore.put(value);
      putPackageRequest.onsuccess = function(event) {
        //console.log(name + " arraybuffer writed success");
      };

      putPackageRequest.onerror = function(error) {
        //console.log(name + " arraybuffer writed error");
      };
    }
    else {
      console.log(tableName + ":该表不存在!");
    }
  } else {
    console.log(dataName + ":保存数据有问题!");
  }
};

EV_IndexedDBProvider.prototype.downloadTerrainData = function(dataName, version, tableName, terrainData, errorCallback, successCallback) {
  if (defined(this._iDB) && this._iDB.name === dataName && this._iDB.version === version) {
    if (this._iDB.objectStoreNames.contains(tableName)) {
      var transaction = this._iDB.transaction([tableName], "readonly");
      var objectStore = transaction.objectStore(tableName);

      var curTerrainData = terrainData;
      var index = objectStore.index("name");
      var reqCursor = index.openCursor(IDBKeyRange.only(curTerrainData.keyName));
      reqCursor.onsuccess = function(e) {
        var cursor = e.target.result;
        if (cursor) {
          terrainData.level = cursor.value.level;
          terrainData.x = cursor.value.x;
          terrainData.y = cursor.value.y;
          terrainData.upsample = cursor.value.upsample;
          successCallback(terrainData, cursor.value.data);
        } else {
          errorCallback(terrainData);
        }
      };

      reqCursor.onerror = function(e) {
        console.log("索引查询失败!");
      };
    }
    else {
      errorCallback(terrainData);
    }
  } else {
    console.log(dataName + ":下载数据有问题!");
  }
};

EV_IndexedDBProvider.prototype.save3DTileArrayBuffer = function(dataName, version, tableName, cesium3DTileData,callbackFunc) {
  if (defined(this._iDB) && this._iDB.name === dataName && this._iDB.version === version) {
    if (this._iDB.objectStoreNames.contains(tableName)) {
      var transaction = this._iDB.transaction([tableName], "readwrite");
      var objectStore = transaction.objectStore(tableName);
      // if(Math.ceil(cesium3DTileData.arrayBuffer.byteLength / CHUNK_SIZE) > 1){
      //     console.log('error:This is needed as chromium has a limit 60MB on per-entry files in IndexedDB');
      // }
      var name = cesium3DTileData.keyName;
      var value = {
        "name": name,
        "meshPrimitives": cesium3DTileData.meshPrimitives,
        "data": cesium3DTileData.data
      };
      var putPackageRequest = objectStore.put(value);
      putPackageRequest.onsuccess = function(event) {
          if (defined(callbackFunc)) {
              callbackFunc("upgradeneeded");
          }
      };

      putPackageRequest.onerror = function(error) {
          if (defined(callbackFunc)) {
              callbackFunc("upgradeneeded");
          }
      };
    }
    else {
      console.log(tableName + ":该表不存在!");
    }
  } else {
    console.log(dataName + ":保存数据有问题!");
  }
};

EV_IndexedDBProvider.prototype.download3DTileArrayBuffer = function(dataName, version, tableName, cesium3DTileData, errorCallback, successCallback) {
  if (defined(this._iDB) && this._iDB.name === dataName && this._iDB.version === version) {
    if (this._iDB.objectStoreNames.contains(tableName)) {
      var transaction = this._iDB.transaction([tableName], "readonly");
      var objectStore = transaction.objectStore(tableName);

      var cur3DTileData = cesium3DTileData;
      var curName = cur3DTileData.keyName;
      var index = objectStore.index("name");
      var reqCursor = index.openCursor(IDBKeyRange.only(curName));
      reqCursor.onsuccess = function(e) {
        var cursor = e.target.result;
        if (cursor) {
          cur3DTileData.meshPrimitives = cursor.value.meshPrimitives;
          successCallback(cur3DTileData, cursor.value.data);
        } else {
          errorCallback(cur3DTileData);
        }
      };

      reqCursor.onerror = function(e) {
        console.log("索引查询失败!");
      };
    }
    else {
      console.log(tableName + ":数据库中不存在该表名!");
    }
  } else {
    console.log(dataName + ":下载数据有问题!");
  }
};

export default EV_IndexedDBProvider;
